import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
// import * as Contracts from '../../Store/Contracts';
import * as ContractConfirm from './Saga/ContractConfirm';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import WebIcon from '@material-ui/icons/Web';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import Backup from '@material-ui/icons/Backup';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SubjectIcon from '@material-ui/icons/Subject';
import { Modal, Row, Col, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import './Css/Grid.css';
// import '../../Css/Grid.css';
import moment from 'moment'
import { IconButton } from '@material-ui/core';

interface Props {
  contract_confirm_rent_contracts_list: any,
  update_contract_confirm_rent_contracts: any,
  users: any,
  user_details: any,
  update_contract_confirm_contract_doc_at: any,
}



interface State {
  modal: boolean;
  modal_contacts: boolean;
  modal_replace: boolean;
  change: boolean;
  search: any;
  columnWidths: any;
  modal_tinkaku: boolean;
  modal_contract_id: any;
  modal_workflow_id: any;
  refresh: boolean;
  sortBy: string | null;
  sortDir: string | null;
}


const defaultColumnProperties = {
  sortable: true,
  // width: 120
};

const SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

const jaCollator = new Intl.Collator('ja', {
  numeric: true,
  sensitivity: 'base',
});

function reverseSortDirection(sortDir: string) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

class SortHeaderCell extends React.Component<any> {
  constructor(props: any) {
    super(props);
    this._onSortChange = this._onSortChange.bind(this);
  }

  _onSortChange(e: any) {
    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ? reverseSortDirection(this.props.sortDir) : SortTypes.DESC
      );
    }
  }

  render() {
    const { onSortChange, sortDir, children, ...props } = this.props;

    return (
      <Cell {...props} onClick={this._onSortChange}>
        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}
      </Cell>
    );
  }
}





class ContractConfirmGrid extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      modal: false,
      modal_contacts: false,
      modal_replace: false,
      // modalselect: false,
      change: false,
      search: '',
      modal_tinkaku: false,
      modal_contract_id: '',
      modal_workflow_id: '',
      refresh: false,
      sortBy: null,
      sortDir: null,

      columnWidths: {
        application_date: 80,
        contract_date: 80,
        cloudsign_completed_at: 80,
        credit_entry_at: 130,
        contractor_name1: 230,
        contractor_kana1: 180,
        building_name: 190,
        room_name: 60,
        contract_money: 120,
        bk_no: 35,
        payment_date: 100,
        payment_type: 80,
        apply_payment_type: 80,
        month_payment_type: 80,
        cancel_date: 100,

        division: 40,
        section_name: 130,
        user_name: 50,
        contract_doc_got_at: 90,
        log_confirm: 40,
        ver: 40,
        contract_doc_print_count: 40,
        contract_doc_first_dl_at: 90,
        status: 40,
        change_contents: 150,
        status2: 90,

        rent_m_contract_type_name: 90,
        rent_m_guarantee_name: 90,
        contract_form: 90,
        yachin: 90,
        getugaku_hosyo: 90,
        siki: 90,
      }
    };

    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this._rowClassNameGetter = this._rowClassNameGetter.bind(this);
    this.onClickUpdateContractDocAt = this.onClickUpdateContractDocAt.bind(this);
    this._onSortChange = this._onSortChange.bind(this);
  }

  _onColumnResizeEndCallback(newColumnWidth: any, columnKey: any) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth,
      },
    }));
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.contract_confirm_rent_contracts_list !== this.props.contract_confirm_rent_contracts_list) {
      if (this.state.sortBy || this.state.sortDir) {
        this.setState({
          sortBy: null,
          sortDir: null,
        });
      }
    }
  }

  _rowClassNameGetter(index: any){
    const rows = this.getSortedRows();

    if(rows && rows[index]) {

      if(
          (
            rows[index].status == 1 || 
            rows[index].status == 2 || 
            rows[index].status == 6 || 
            rows[index].status == 8 || 
            rows[index].status == 9 || 
            (rows[index].status == 10 && rows[index].contract_doc_first_dl_at != null )
          ) && (
            (rows[index].log_confirm != rows[index].ver) || 
            (rows[index].contract_doc_first_dl_at != null && rows[index].contract_doc_first_dl_confirm_at == null && rows[index].cloudsign_completed_at == null)
          )
        ) {

          // return "edit"
          // alert(this.props.contract_confirm_rent_contracts_list[index].bk_no > 0 && (this.props.contract_confirm_rent_contracts_list[index].ver != this.props.contract_confirm_rent_contracts_list[index].log_confirm) ? "edit" : this.props.contract_confirm_rent_contracts_list[index].cancel_date && this.props.contract_confirm_rent_contracts_list[index].bk_no > 0 ? "cancel_zumi" : this.props.contract_confirm_rent_contracts_list[index].cancel_date ? "cancel_mi" : this.props.contract_confirm_rent_contracts_list[index].cloudsign_completed_at && (this.props.contract_confirm_rent_contracts_list[index].payment_type == 2 || this.props.contract_confirm_rent_contracts_list[index].apply_payment_type == 1) ? "completed" : "")
          // return this.props.contract_confirm_rent_contracts_list[index].cancel_date && this.props.contract_confirm_rent_contracts_list[index].bk_no > 0 ? "cancel_zumi" : 
          return rows[index].cancel_date ? "cancel_zumi" : 
          // this.props.contract_confirm_rent_contracts_list[index].log_confirm == 0 && this.props.contract_confirm_rent_contracts_list[index].pm_confirm != this.props.contract_confirm_rent_contracts_list[index].workflow_count ? "new" :
          // this.props.contract_confirm_rent_contracts_list[index].cancel_date ? "cancel_mi" : 
          rows[index].bk_no > 0 && (rows[index].ver != rows[index].log_confirm) ? "edit" : 
          rows[index].contract_doc_first_dl_at != null && rows[index].contract_doc_first_dl_confirm_at == null ? "mikakunin" :"new"
      
      
      }else{
        return "new"
      }
    
    }else{
      return ""
    }
  }

  openRentResponses(id: any) {
    // window.open("https://crm.homestation.jp/customer/" + id, '_blank', 'noopener')
    window.open("https://crmnext.homestation.jp/Contracts/?conid=" + id, '_blank', 'noopener')
    
  }
  openRentContracts(contract_id: any, workflow_id: any) {
    // alert(contract_id)
    // alert(workflow_id)
    window.open("http://192.168.0.202/fuelphp/public/contraction/link/new?rent_contract_id=" + contract_id, '_blank', 'noopener')
    this.props.update_contract_confirm_rent_contracts(workflow_id)

    this.setState({ 
      refresh: !this.state.refresh,
      modal_tinkaku: false, 
      modal_contract_id: '', 
      modal_workflow_id: ''
    })
    
  }


  openSheet(id: any) {
    // alert(id)
    window.open("https://www.homestation.jp/manage/rent/sheet/followsheet/pdfazurep?keiri=1&c_id=" + id, '_blank', 'noopener')
  }

  onClickUpdateContractDocAt(workflow_id:any, user_id:any){
    this.props.update_contract_confirm_contract_doc_at({workflow_id: workflow_id, user_id: user_id})

    this.setState({
      refresh: !this.state.refresh    //再描画
    })
  }

  _onSortChange(columnKey: string, sortDir: string) {
    this.setState({
      sortBy: columnKey,
      sortDir,
    });
  }

  getSortValue(row: any, columnKey: string) {
    switch (columnKey) {
      case 'densi':
        return row.cloudsign_completed_at ? 1 : 0;
      case 'status2':
        return row.status;
      default:
        return row[columnKey];
    }
  }

  normalizeSortValue(value: any) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (typeof value === 'boolean') {
      return value ? 1 : 0;
    }

    if (typeof value === 'string') {
      const isDateString = /^\d{4}[-/]\d{2}[-/]\d{2}/.test(value) || /^\d{4}-\d{2}-\d{2}T/.test(value);
      if (isDateString) {
        const parsedDate = moment(value);
        if (parsedDate.isValid()) {
          return parsedDate.valueOf();
        }
      }

      if (!isNaN(Number(value)) && value.trim() !== '') {
        return Number(value);
      }

      return value.toLowerCase();
    }

    return value;
  }

  getSortedRows() {
    const rows = this.props.contract_confirm_rent_contracts_list || [];
    const { sortBy, sortDir } = this.state;

    if (!sortBy || !sortDir) {
      return rows;
    }

    return [...rows].sort((a: any, b: any) => {
      const aValue = this.normalizeSortValue(this.getSortValue(a, sortBy));
      const bValue = this.normalizeSortValue(this.getSortValue(b, sortBy));

      if (aValue === bValue) {
        return 0;
      }

      if (aValue === null) {
        return 1;
      }

      if (bValue === null) {
        return -1;
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const compareResult = jaCollator.compare(aValue, bValue);
        return sortDir === SortTypes.ASC ? compareResult : compareResult * -1;
      }

      if (aValue > bValue) {
        return sortDir === SortTypes.ASC ? 1 : -1;
      }

      return sortDir === SortTypes.ASC ? -1 : 1;
    });
  }

  renderHeader(label: string, columnKey: string, sortable: boolean = true) {
    if (!sortable) {
      return <Cell>{label}</Cell>;
    }

    return (
      <SortHeaderCell
        columnKey={columnKey}
        onSortChange={this._onSortChange}
        sortDir={this.state.sortBy === columnKey ? this.state.sortDir : null}
      >
        {label}
      </SortHeaderCell>
    );
  }


  render() {
    const rows = this.getSortedRows();

    return (
      <div style={{width:"100%"}}>
        
        <Chip style={{float:"right"}} label={rows ? rows.length + "件" : ""} variant="outlined" ></Chip>
        
        <div style={{float:"right", marginTop:4}}>
          {/* <div style={{backgroundColor:"rgb(167, 167, 167)", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3}}>キャンセル(賃革未登録)</div> */}
          <div style={{backgroundColor:"rgb(255, 148, 148)", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3}}>キャンセル</div>
          <div style={{backgroundColor:"#5badff", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3}}>契約書未確認</div>
          {/* <div style={{backgroundColor:"#1e90ff", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3}}>契約締結済</div> */}
          {/* <div style={{backgroundColor:"rgb(252, 252, 252)", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3, border:"1px solid #c5c5c5"}}>契約締結待ち</div> */}
          <div style={{backgroundColor:"rgb(255, 202, 87)", float:"left", fontSize:"11px", marginRight:5, padding:3, borderRadius:3}}>変更あり</div>

        </div>
        
        <div style={{clear:"both"}}></div>
        {rows ? <Table
          rowHeight={42}
          rowsCount={rows.length}
          width={window.innerWidth - 300}
          height={window.innerHeight - 110}
          headerHeight={34}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
          className="gridContractConfirm"
          rowClassNameGetter={this._rowClassNameGetter}
          
        >
          <Column width={40} header={<Cell>詳細</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}><IconButton style={{ marginTop: -10 }} onClick={() => this.openRentResponses(rows[rowIndex].id)} size="small" ><AccountBoxIcon style={{ color: "#4f5357" }} /></IconButton></Cell>)} />
          <Column width={40} header={<Cell><span style={{fontSize:13}}>シート</span></Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}><IconButton style={{ marginTop: -10 }} onClick={() => this.openSheet(rows[rowIndex].id)} size="small" ><SubjectIcon style={{ color: "#4f5357" }} /></IconButton></Cell>)} />
          {/* <Column width={50} header={<Cell>賃革</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}><IconButton style={{ marginTop: -10 }} onClick={(e) => { this.setState({ "modal_tinkaku": true, "modal_contract_id": this.props.contract_confirm_rent_contracts_list[rowIndex].id, "modal_workflow_id": this.props.contract_confirm_rent_contracts_list[rowIndex].workflow_id }) }} size="small"><Backup style={{ color: "#4f5357" }} /></IconButton></Cell>)} /> */}
          
          <Column width={this.state.columnWidths.bk_no} isResizable={true} columnKey={"bk_no"} 
            header={this.renderHeader("賃革", "bk_no")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].bk_no > 0 ? "済" : "未"}</Cell>)} />
          <Column width={35} isResizable={true} columnKey={"densi"} 
            header={this.renderHeader("電契", "densi")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].cloudsign_completed_at ? <CloudDoneIcon /> : ""}</Cell>)} />
          
          <Column width={this.state.columnWidths.status2} isResizable={true} columnKey={"status2"} 
            header={this.renderHeader("状況", "status2")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>
              {rows[rowIndex].status == 1 ? "特約確認必要" :
              rows[rowIndex].status == 2 ? "確認済み" :
              rows[rowIndex].status == 5 ? "店長承認" :
              rows[rowIndex].status == 6 ? "キャンセル" :
              rows[rowIndex].status == 8 ? "変更特約確認必要" :
              rows[rowIndex].status == 9 ? "店長承認未印刷" : 
              rows[rowIndex].status ==10 ? "店長承認" :
              rows[rowIndex].status == 0 ? "店長承認待ち" : ""}
            </Cell>)} />
          
          <Column width={this.state.columnWidths.application_date} isResizable={true} columnKey={"application_date"} 
            header={this.renderHeader("申込日", "application_date")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{moment(rows[rowIndex].application_date).format("YYYY-MM-DD")}</Cell>)} />
          <Column width={this.state.columnWidths.contract_date} isResizable={true} columnKey={"contract_date"} 
            header={this.renderHeader("契約日", "contract_date")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{moment(rows[rowIndex].contract_date).format("YYYY-MM-DD")}</Cell>)} />
          <Column width={this.state.columnWidths.cloudsign_completed_at} isResizable={true} columnKey={"cloudsign_completed_at"} 
            header={this.renderHeader("電契締結日", "cloudsign_completed_at")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].cloudsign_completed_at ? moment(rows[rowIndex].cloudsign_completed_at).format("YYYY-MM-DD"):""}</Cell>)} />
          
          <Column width={this.state.columnWidths.section_name} isResizable={true} columnKey={"section_name"} 
            header={this.renderHeader("店舗", "section_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].section_name}</Cell>)} />
          <Column width={this.state.columnWidths.user_name} isResizable={true} columnKey={"user_name"} 
            header={this.renderHeader("担当", "user_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].user_name}</Cell>)} />
          

          <Column width={this.state.columnWidths.contractor_name1} isResizable={true} columnKey={"contractor_name1"} 
            header={this.renderHeader("契約者", "contractor_name1")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}><div style={{fontSize:10, whiteSpace: "nowrap"}}>{rows[rowIndex].contractor_kana1}</div><div>{rows[rowIndex].contractor_name1}</div></Cell>)} />
          <Column width={this.state.columnWidths.division} isResizable={true} columnKey={"division"} 
            header={this.renderHeader("区分", "division")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].division == 1 ? "サブ" : rows[rowIndex].division == 2  ? "管理" : rows[rowIndex].division == 3 ? "一般" : rows[rowIndex].division == 4 ? "業物" : rows[rowIndex].division == 5 ? "業物折半" : rows[rowIndex].division == 6 ? "専任" : ""}</Cell>)} />
          <Column width={this.state.columnWidths.building_name} isResizable={true} columnKey={"building_name"} 
            header={this.renderHeader("物件名", "building_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].building_name}</Cell>)} />
          <Column width={this.state.columnWidths.room_name} isResizable={true} columnKey={"room_name"} 
            header={this.renderHeader("号", "room_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].room_name}</Cell>)} />
          

          <Column width={this.state.columnWidths.contract_doc_got_at} isResizable={true} columnKey={"contract_doc_got_at"} 
            header={this.renderHeader("契約書回収", "contract_doc_got_at")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>
              {(() => {
                if(!rows[rowIndex].cloudsign_completed_at){
                if(rows[rowIndex].contract_doc_got_at){
                  return <Button size='small' color="primary" variant="contained" onClick={()=>this.onClickUpdateContractDocAt(rows[rowIndex].workflow_id, 0)}>
                  {rows[rowIndex].contract_doc_get_user_id && this.props.users.length > 0 ? this.props.users.filter((a:any)=>a.id == rows[rowIndex].contract_doc_get_user_id)[0].nickname : ""}
                  {moment(rows[rowIndex].contract_doc_got_at).format("MM/DD")}
                  </Button>
                }else{
                  return <Button color="secondary" size="small" variant="contained" onClick={()=>this.onClickUpdateContractDocAt(rows[rowIndex].workflow_id, this.props.user_details.id)}>未</Button>
                }
              }else{
                return ""
              }
              })()}
              
              </Cell>)} />
          <Column width={this.state.columnWidths.change_contents} isResizable={true} columnKey={"change_contents"} 
            header={this.renderHeader("変更内容", "change_contents")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].change_contents}</Cell>)} />
          
          <Column width={this.state.columnWidths.log_confirm} isResizable={true} columnKey={"log_confirm"} 
            header={this.renderHeader("確認済", "log_confirm")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].log_confirm}</Cell>)} />
          <Column width={this.state.columnWidths.ver} isResizable={true} columnKey={"ver"} 
            header={this.renderHeader("更新数", "ver")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].ver}</Cell>)} />
          <Column width={this.state.columnWidths.contract_doc_print_count} isResizable={true} columnKey={"contract_doc_print_count"} 
            header={this.renderHeader("DL", "contract_doc_print_count")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].contract_doc_print_count}</Cell>)} />
          <Column width={this.state.columnWidths.contract_doc_first_dl_at} isResizable={true} columnKey={"contract_doc_first_dl_at"} 
            header={this.renderHeader("初回DL", "contract_doc_first_dl_at")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].contract_doc_first_dl_at ? moment(rows[rowIndex].contract_doc_first_dl_at).utc().format("YYYY/MM/DD HH:mm:ss") : ""}</Cell>)} />
          <Column width={this.state.columnWidths.status} isResizable={true} columnKey={"status"} 
            header={this.renderHeader("状態", "status")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].status}</Cell>)} />
          
          <Column width={this.state.columnWidths.rent_m_contract_type_name} isResizable={true} columnKey={"rent_m_contract_type_name"} 
            header={this.renderHeader("契約プラン", "rent_m_contract_type_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].rent_m_contract_type_name}</Cell>)} />
          <Column width={this.state.columnWidths.rent_m_guarantee_name} isResizable={true} columnKey={"rent_m_guarantee_name"} 
            header={this.renderHeader("保証会社", "rent_m_guarantee_name")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].rent_m_guarantee_name}</Cell>)} />
          <Column width={this.state.columnWidths.contract_form} isResizable={true} columnKey={"contract_form"} 
            header={this.renderHeader("個人／法人", "contract_form")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].contract_form == 1 ? "法人":"個人"}</Cell>)} />
          <Column width={this.state.columnWidths.yachin} isResizable={true} columnKey={"yachin"} 
            header={this.renderHeader("家賃", "yachin")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].yachin?rows[rowIndex].yachin.toLocaleString() : ""}</Cell>)} />
          <Column width={this.state.columnWidths.getugaku_hosyo} isResizable={true} columnKey={"getugaku_hosyo"} 
            header={this.renderHeader("月額保証料", "getugaku_hosyo")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].getugaku_hosyo}</Cell>)} />
          <Column width={this.state.columnWidths.siki} isResizable={true} columnKey={"siki"} 
            header={this.renderHeader("敷金", "siki")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].siki ? rows[rowIndex].siki+"ヶ月":""}</Cell>)} />
          
          
          
          <Column width={this.state.columnWidths.cancel_date} isResizable={true} columnKey={"cancel_date"} 
            header={this.renderHeader("キャンセル日", "cancel_date")} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{rows[rowIndex].cancel_date ? moment(rows[rowIndex].cancel_date).format("YYYY-MM-DD"):""}</Cell>)} />
        </Table> : ""}


        <Modal isOpen={this.state.modal_tinkaku} fade={false} className="modal-dialog-centered">
          <ModalBody>
            <div>賃貸革命へデータを登録します。よろしいですか？</div>
          </ModalBody>
          <ModalFooter>
            <Button variant="contained" color="primary" onClick={() => this.openRentContracts(this.state.modal_contract_id, this.state.modal_workflow_id)}>登録</Button>
            <Button variant="contained" style={{ marginLeft: 3 }} onClick={(e) => { this.setState({ "modal_tinkaku": false, "modal_contract_id": '', "modal_workflow_id": '' }) }}>閉じる</Button>
          </ModalFooter>

        </Modal>
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    contract_confirm_rent_contracts_list: state.ContractConfirm.contract_confirm_rent_contracts_list,
    users: state.masterReducer.users,
    user_details: state.masterReducer.user_details,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    update_contract_confirm_rent_contracts(state: any) {
      dispatch(ContractConfirm.update_contract_confirm_rent_contracts(state))
    },
    update_contract_confirm_contract_doc_at(state: any) {
      dispatch(ContractConfirm.update_contract_confirm_contract_doc_at(state))
    },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractConfirmGrid);
